import React from "react"
import classNames from "classnames"

import styles from "./index.module.less"

interface IRegistryButtonProps {
    type: string
    className?: string
    onClick?: () => void
}

const RegistryButton: React.FC<IRegistryButtonProps> = (props) => {
    const { className, onClick, type } = props

    return (
        <div
            className={classNames(
                styles.registryButton,
                styles[type],
                className
            )}
            onClick={onClick}
        >
            <div className={classNames(styles.label, styles[type])}></div>
        </div>
    )
}

export default RegistryButton
